import styled from 'styled-components'

import { IconAlertBig } from 'components/Icons/IconAlertBig'
import { Typography } from 'components/Typography/Typography'

const ErrorContainer = styled.div`
  margin-top: 16px;
  padding: 12px 8px;
  border-radius: 8px;
  border: 1px solid ${p => p.theme.colors.border};
  background: ${p => p.theme.colors.background.secondary};
  & > div {
    display: flex;
    align-items: center;
    svg {
      margin-right: 8px;
      path {
        stroke: ${p => p.theme.colors.text.danger};
      }
    }
  }
`

export const WithdrawError = () => (
  <ErrorContainer>
    <Typography color="danger" variant="caption">
      <div style={{ display: 'flex' }}>
        <IconAlertBig width={16} height={16} />
      </div>
      Transaction simulation has failed! Try changing aggregator or increasing slippage.
    </Typography>
  </ErrorContainer>
)
